import { resolveAeternaAssetPath } from "./assetBase";

const MONSTER_IMAGE_BASE = resolveAeternaAssetPath("/assets/monsters");
const MONSTER_IMAGE_EXTENSION = ".webp";
const LEGACY_MONSTER_IMAGE_EXTENSION = ".svg";

function normalizeMonsterImageFile(monsterId, image) {
  if (typeof image === "string" && image.trim()) {
    const trimmed = image.trim();
    if (trimmed.endsWith(MONSTER_IMAGE_EXTENSION)) return trimmed;
    if (trimmed.endsWith(LEGACY_MONSTER_IMAGE_EXTENSION)) {
      return `${trimmed.slice(0, -LEGACY_MONSTER_IMAGE_EXTENSION.length)}${MONSTER_IMAGE_EXTENSION}`;
    }
    if (trimmed.includes(".")) return trimmed;
    return `${trimmed}${MONSTER_IMAGE_EXTENSION}`;
  }
  if (typeof monsterId === "string" && monsterId.trim()) {
    return `${monsterId.trim()}${MONSTER_IMAGE_EXTENSION}`;
  }
  return null;
}

export function getMonsterImageUrl(source) {
  if (!source) return null;
  if (typeof source === "string") {
    const file = normalizeMonsterImageFile(source);
    return file ? `${MONSTER_IMAGE_BASE}/${file}` : null;
  }
  if (typeof source.imageUrl === "string" && source.imageUrl.trim()) {
    return source.imageUrl.trim();
  }
  const monsterId =
    typeof source.monsterId === "string"
      ? source.monsterId
      : typeof source.templateId === "string"
        ? source.templateId
        : typeof source.id === "string"
          ? source.id
          : null;
  const file = normalizeMonsterImageFile(monsterId, source.image);
  return file ? `${MONSTER_IMAGE_BASE}/${file}` : null;
}
